import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AnalyticsProfile,
  GetEmployeesQueryVariables,
  RegistrationStatus,
  ReportNames,
  useGetOrganicInsightsReportQuery,
} from 'api';
import { InfiniteQuery } from 'types/app';
import { useNotify } from 'hooks';

import ExportData from 'features/admin/components/shared/ExportData';
import { Stack, Typography } from '@mui/material';

interface Props {
  variables: GetEmployeesQueryVariables;
  queryOptions: InfiniteQuery<AnalyticsProfile>;
}

const IdentifiedActions: FC<Props> = ({ variables, queryOptions }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const [requestReport, setRequestReport] = useState(false);
  const { count } = queryOptions;

  console.log(count);

  useGetOrganicInsightsReportQuery(
    {
      start: variables.start,
      end: variables.end,
      report: ReportNames.Employee,
      organic_insights_report_filter: {
        registration_status: RegistrationStatus.Unregistered,
      },
      advanced_filters: {},
    },
    {
      enabled: requestReport,
      onError: () => notify.error({ message: t('analytics:reportRequestedError') }),
      onSettled: () => setRequestReport(false),
    }
  );

  function onClickExportData() {
    notify.info({ message: t('analytics:reportRequested') });
    setRequestReport(true);
  }

  return (
    <Stack alignItems="center" direction="row" spacing={2}>
      {!!count && (
        <Typography variant="subtitle2" lineHeight="normal">
          {t('insights:total_result', { count: count })}
        </Typography>
      )}
      <ExportData onClick={onClickExportData} />
    </Stack>
  );
};

export default IdentifiedActions;
